import React, {Component} from 'react'
import RequestForgotPasswordForm from '../components/RequestForgotPasswordForm'

class ForgotPasswordPage extends Component {
  render() {
    return <RequestForgotPasswordForm />
  }
}

export default ForgotPasswordPage